import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Text } from "../../../../components/Text";
import modulesName from "../../../../roles/modulesName";
import permissions from "../../../../roles/permissions";
import { API_GET_ALL_AGENTS } from "../../../../api/account.service";
import { Dropdown } from "primereact/dropdown";
import { Divider } from "primereact/divider";
import { CustomButton } from "../../../../components/CustomButton";
import { Tooltip } from "primereact/tooltip";
import CustomSaveModel from "../../../../components/CustomeSaveModel";
import CONSTANTS from "../../../../config/Constants";
import { migrateAgentChatGroups } from "../../../../reducers/chatSettingSlice";
import { Toast } from "primereact/toast";

const ChatMigration = () => {
  const { accesskey } = useSelector((state) => state.authenticate);
  const [selectedAgent, setSelectedAgent] = useState("");
  const [selectedToAgent, setSelectedToAgent] = useState("");
  const [allAgents, setAllAgents] = useState([]);
  const [showSave, setShowSave] = useState(false);
  const dispatch = useDispatch();
  const toast = useRef(null);

  useEffect(() => {
    if (accesskey[modulesName.SALES]?.includes(permissions.CREATE)) {
      API_GET_ALL_AGENTS()
        .then((data) => {
          let supportAgents = data.user.rows.map((agent) => {
            return { value: agent?.id, label: agent?.userName };
          });
          setAllAgents(supportAgents);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    }
  }, []);

  const SaveModel = () => {
    return (
      <CustomSaveModel
        showSave={showSave}
        header={alertText()}
        dialogFooter={dialogFooter}
        onHide={onHide}
      />
    );
  };
  const alertText = () => {
    return <div>{CONSTANTS.MIGRATE_AGENTS_CHAT}</div>;
  };
  const dialogFooter = () => {
    return (
      <div className="flex justify-content-end ">
        <CustomButton
          label="Cancel"
          varient="cancel"
          autofocus={true}
          onClick={() => {
            setShowSave(false);
          }}
        />
        <CustomButton
          label="Confirm"
          varient="filled"
          onClick={maigrateAgentCaht}
        />
      </div>
    );
  };
  const onHide = () => {
    setShowSave(false);
  };

  const maigrateAgentCaht = () => {
    let payloadData = {
      oldAgentId: selectedAgent,
      newAgentId: selectedToAgent,
    };
    dispatch(migrateAgentChatGroups(payloadData))
      ?.unwrap()
      ?.then((res) => {
        toast.current.show({
          severity: "success",
          detail: `All Firebase messages deleted successfully.`,
          life: 3000,
        });
        onHide();
        setSelectedAgent("");
        setSelectedToAgent("");
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          detail: err?.error || err?.message,
          life: 3000,
        });
      });
  };
  return (
    <div>
      <Toast ref={toast} />
      <SaveModel />
      <div className="flex items-center gap-2">
        <Text type={"heading"}>Transfer Agent Chats</Text>
        <i
          className="pi pi-info-circle text-gray-500"
          data-pr-tooltip="Allows users to assign one agent's chat history to another agent for workflow transitions."
        ></i>
      </div>
      <Tooltip target=".pi-info-circle" />
      <Divider />
      <div className="">
        <div className="field mt-3 col-3">
          <label htmlFor="otherFilter">From Agent</label>
          <Dropdown
            id="otherFilter"
            value={selectedAgent}
            options={allAgents}
            onChange={(e) => setSelectedAgent(e.value)}
            placeholder="Select an Option"
            className="w-full"
          />
        </div>
        <div className="field mt-3 col-3">
          <label htmlFor="otherFilter">To Agent</label>
          <Dropdown
            id="otherFilter"
            value={selectedToAgent}
            options={allAgents}
            onChange={(e) => setSelectedToAgent(e.value)}
            placeholder="Select an Option"
            className="w-full"
          />
        </div>
      </div>
      <div className="mx-2">
        <CustomButton
          label={"Migrate Chats"}
          onClick={() => setShowSave(true)}
          disabled={selectedAgent && selectedToAgent ? false : true}
        />
      </div>
    </div>
  );
};

export default ChatMigration;
